document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('js-disabled')
})
